import { render, staticRenderFns } from "./EtapasSide.vue?vue&type=template&id=520b3132&scoped=true&"
import script from "./EtapasSide.vue?vue&type=script&lang=js&"
export * from "./EtapasSide.vue?vue&type=script&lang=js&"
import style0 from "./EtapasSide.vue?vue&type=style&index=0&id=520b3132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b3132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperContent,VStepperStep})
